module.exports = __webpack_public_path__ + "img/sort_indicator.543505ce.svg";